import script from "./VButtonSubmitAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./VButtonSubmitAuth.vue?vue&type=script&setup=true&lang=js"

import "./VButtonSubmitAuth.vue?vue&type=style&index=0&id=921d17d4&lang=css"

const __exports__ = script;

export default __exports__